import { IFilterItem } from "../models/filter-item-model";
import { IFixedFilter } from "@/shared/models/view/fixed-filter-model";
import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFilterQueryService } from "./interfaces/filter-query-service-interface";

export abstract class BaseFilterQueryService implements IFilterQueryService {
    public filter: string = '';

    public abstract addUserFilter(filters: IDictionary<IFilterItem[]>): BaseFilterQueryService

    public addFixedFilter(fixedFilters: IDictionary<IFixedFilter>): BaseFilterQueryService {
        Object.keys(fixedFilters)?.forEach((name) => {
            fixedFilters[name]?.Values.forEach((value) => {
                let filter: string = ''

                switch (name) {
                    case "Language":
                        filter = this.getSingleSyntax(name, value, fixedFilters[name].LogicalOperator)
                        break;
                    default:
                        filter = this.getListSyntax(name, [value]);
                        break;
                }

                this.appendFilter(filter);
            })
        })

        return this
    }

    public addScopesFilter(scopes: IFilterItem[]): BaseFilterQueryService {
        if (scopes && scopes.length) {
            let query = this.getListSyntax('Scopes', scopes.map(x => x.CodeName))
            this.appendFilter(query)
        }

        return this
    }

    public appendFilter(filter: string): void {
        this.filter = this.filter ? `${this.filter} and ${filter}` : filter;
    }

    public getSingleSyntax(filter: string, value: string, logicalOperator: string): string {
        return `${filter} ${logicalOperator} '${value}'`;
    }

    public getListSyntax(filter: string, values: string[]): string {
        return `${filter}/any(c: search.in(c, '${values.join('|')}', '|'))`;
    }
}


